import * as React from 'react';
import { ReactNode } from 'react';

interface Props {
    errorMessage?: ReactNode;
    successMessage?: string;
    className?: string;
}

const FormValidationDisplay = (props: Props) => {
    return (
        <div className={props.className}>
            {!props.successMessage && props.errorMessage && (
                <div className="alert alert-danger" role="alert">
                    {props.errorMessage}
                </div>
            )}
            {props.successMessage && (
                <div className="alert alert-success" role="alert">
                    {props.successMessage}
                </div>
            )}
        </div>
    );
};

export default FormValidationDisplay;



// WEBPACK FOOTER //
// ./src/components/common/form/ValidationDisplay.tsx